import { apiEndpointProd } from "project.config"

const apiBaseUrl = String(apiEndpointProd || "").replace(/\/+$/, "")

export function resolveMediaUrl(url) {
  if (!url) return ""

  const value = String(url).trim()
  if (!value) return ""

  if (
    value.startsWith("data:") ||
    value.startsWith("blob:") ||
    /^https?:\/\//i.test(value)
  ) {
    return value
  }

  if (value.startsWith("//")) {
    return `https:${value}`
  }

  if (value.startsWith("/media/")) {
    return `${apiBaseUrl}${value}`
  }

  if (/^[a-z0-9.-]+\/media\//i.test(value)) {
    return `https://${value}`
  }

  return value
}
